<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title">AVISO</h5>
  </div>
  <div class="modal-body">
    <strong>Seus créditos para o Mentor Virtual acabaram</strong>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-link mainFontColor" data-dismiss="modal" (click)="activeModal.dismiss()">Fechar</button>
    <button type="button" class="btn btn-primary mainBackground-color" (click)="accept()">Comprar</button>
  </div>
</div>